module.exports = __webpack_public_path__ + "static/media/FileTextHover.bc8c93ad.svg";